import { useAccountContext } from '../../../contexts';

export default function useAddApplicant() {
  const { appendToAccountArray } = useAccountContext();

  return () => {
    appendToAccountArray('applicants', {});
  };
}
